export default __webpack_public_path__ + "static/brand-colors-light-b6fbae44727a4996b407904bd00a0afa.png";